// removed by extract-text-webpack-plugin
module.exports = {"item":"item_3_fNs","active":"active_36owo","fill":"fill_1eqYS"};


//////////////////
// WEBPACK FOOTER
// ./app/components/menu-item/styles.scss
// module id = 449
// module chunks = 1